var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5C4.5 3.80653 4.97411 2.66193 5.81802 1.81802C6.66194 0.974106 7.80653 0.5 9 0.5C10.1935 0.5 11.3381 0.974106 12.182 1.81802C13.0259 2.66193 13.5 3.80653 13.5 5C13.5 6.19347 13.0259 7.33807 12.182 8.18198C11.3381 9.02589 10.1935 9.5 9 9.5C7.80653 9.5 6.66194 9.02589 5.81802 8.18198C4.97411 7.33807 4.5 6.19347 4.5 5ZM0.751004 19.105C0.784725 16.9395 1.66865 14.8741 3.21197 13.3546C4.75529 11.8351 6.83422 10.9834 9 10.9834C11.1658 10.9834 13.2447 11.8351 14.788 13.3546C16.3314 14.8741 17.2153 16.9395 17.249 19.105C17.2516 19.2508 17.2117 19.3942 17.134 19.5176C17.0564 19.641 16.9445 19.7392 16.812 19.8C14.3612 20.9237 11.6962 21.5037 9 21.5C6.214 21.5 3.567 20.892 1.188 19.8C1.05549 19.7392 0.94358 19.641 0.865967 19.5176C0.788353 19.3942 0.748403 19.2508 0.751004 19.105Z",
    fill: "#3E1200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.0a14a422a8b4b226f1fde71b4a2f2d85.svg";
export { ForwardRef as ReactComponent };